import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { GoogleBigQueryCopySource } from 'app/model/pipeline/copysource/google-bigquery.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleBigQueryCopySource),
    asynchronous: true,
    disabled: __IS_FABRIC_DPE__,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class GoogleBigQueryCopySourceAdapter extends CopySourceAdapter<
    GoogleBigQueryCopySource,
    Model.GoogleBigQuerySource
> {
    protected override async _toResource(copySource: GoogleBigQueryCopySource): Promise<Model.GoogleBigQuerySource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(GoogleBigQueryCopySource).name);
    }

    protected override async _toModel(
        resource: Model.GoogleBigQuerySource,
        copyActivity: CopyActivity
    ): Promise<GoogleBigQueryCopySource> {
        return this._toTabularModel(resource, copyActivity, GoogleBigQueryCopySource.MODEL);
    }
}
